import { getAuthHeaders } from '../utils/authHeaders';
import { createFormPdf, PDF_COLORS } from '../utils/formPdf';

const API_URL = 'https://app.pvslimited.co.uk/api';

const sendPreCoatingBatchEmail = async (formData) => {
  try {
    const blob = await createFormPdf({
      title: 'PRE COATING BATCH QUALITY FORM',
      ref: 'Ref: PVS-PCB-001 | Version: 1.0',
      subtitle: 'Batch Pre-Coating Quality Control Documentation',
    }, (pdf) => {
      pdf.section('BATCH INFORMATION');
      pdf.field('Batch Number', formData.batchNumber);
      pdf.field('Inspector Name', formData.inspectorName);
      pdf.field('Date', formData.date);
      pdf.field('Number of Vessels in Batch', formData.numberOfVessels);

      pdf.section('PRE-COATING READINESS VALIDATION');
      pdf.field('Surface Preparation Grade', formData.surfacePrepGrade);
      pdf.field('Surface Profile Readings (um)', formData.surfaceProfileReadings);
      pdf.field('Ventilation Status', formData.ventilationStatus);
      pdf.check('Contaminants Removed (Oil/Grease/Salts)', formData.contaminantsRemoved);
      pdf.check('Previous Coating Removed/Feathered As Per Spec', formData.previousCoatingRemoved);

      pdf.section('PRE SPRAY READINGS (INSIDE SPRAY BOOTH)');
      pdf.field('Ambient Temperature (C)', formData.ambientTemperature);
      pdf.field('Relative Humidity (%)', formData.relativeHumidity);
      pdf.field('Substrate Temperature (C)', formData.substrateTemperature);
      pdf.field('Dew Point (C)', formData.calculatedDewPoint);
      pdf.field('Dew Point Spread (C)', formData.dewPointSpread);
      pdf.field('Spray Booth Temperature Set Point (C)', formData.sprayBoothTempSetPoint);
      pdf.check('Steel Pre-heated Prior to Paint Application', formData.steelPreheated);

      pdf.section('PRIMER COAT DFT FINAL CHECK');
      pdf.paragraph(`Minimum requirement: ${formData.primerDftMinimum || 125} um`, {
        size: 10,
        color: PDF_COLORS.muted,
      });
      pdf.field('Primer DFT Low (um)', formData.primerDftLow);
      pdf.field('Primer DFT High (um)', formData.primerDftHigh);
      pdf.field('Primer DFT Average (um)', formData.primerDftAverage);
      pdf.passFail('Result', formData.primerDftPass);

      if (formData.additionalComments) {
        pdf.section('ADDITIONAL COMMENTS');
        pdf.longText('', formData.additionalComments);
      }
    });

    const formDataToSend = new FormData();
    formDataToSend.append('file', blob, `Pre_Coating_Batch_${formData.batchNumber}_${Date.now()}.pdf`);
    formDataToSend.append('batchNumber', formData.batchNumber);
    formDataToSend.append('inspectorName', formData.inspectorName);
    formDataToSend.append('date', formData.date);
    formDataToSend.append('numberOfVessels', formData.numberOfVessels);
    formDataToSend.append('formType', 'pre-coating-batch');

    const response = await fetch(`${API_URL}/send-pre-coating-batch-email`, {
      method: 'POST',
      headers: getAuthHeaders(),
      body: formDataToSend,
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`HTTP error! status: ${response.status}, message: ${errorText}`);
    }

    return response.json();
  } catch (error) {
    console.error('Error in sendPreCoatingBatchEmail:', error);
    throw error;
  }
};

export default sendPreCoatingBatchEmail;
